import sessionStorage from 'redux-persist/lib/storage/session';
import { PersistConfig } from 'redux-persist/lib/types';

import { RootState } from 'app/redux/state/root-state';
import { OrdersState } from 'app/page/orders/redux/model/orders-state';

const rootPersistConfig: PersistConfig<RootState> = {
    key: 'root',
    storage: sessionStorage,
    blacklist: ['router', 'form', 'orders'],
};

const ordersPersistConfig: PersistConfig<OrdersState> = {
    key: 'orders',
    storage: sessionStorage,
    whitelist: ['billingAccounts', 'selectedBillingAccountId', 'availableTime'],
};

export { rootPersistConfig, ordersPersistConfig };
